import React from 'react';
import { useMaxWidth } from '../../hooks/useMaxWidth';
import AdminMobileUnavailable from './AdminMobileUnavailable';

export const DESKTOP_ONLY_MAX_WIDTH = 1024;

interface DesktopOnlyRouteProps {
  children: React.ReactNode;
  title: string;
}

const DesktopOnlyRoute: React.FC<DesktopOnlyRouteProps> = ({ children, title }) => {
  const isMobileViewport = useMaxWidth(DESKTOP_ONLY_MAX_WIDTH);

  if (isMobileViewport) {
    return <AdminMobileUnavailable title={title} />;
  }

  return <>{children}</>;
};

export default DesktopOnlyRoute;
